import React from "react";
import { Link } from "react-router-dom";
import { SkillgarageLogo, NotificationIcon, Helpicon } from "../../../../images";

const Newherotop = () => {
  return (
    <div className="w-full flex h-[92px] justify-between items-center px-6 py-3 bg-white shadow-sm">
      {/* Left: Logo */}
      <Link to="/" className="flex items-center space-x-2" aria-label="Go to homepage">
        <img
          src={SkillgarageLogo}
          alt="The Skill Garage Logo"
        />
      </Link>

      {/* Right: Help & Notifications */}
      <div className="flex items-center text-[14px] space-x-6 text-gray-700">
        <button className="flex items-center space-x-1 hover:text-yellow-500 transition">
          <img
            src={Helpicon}
            alt="Help Icon"
            
          />
          <span className="text-sm font-medium">Help</span>
        </button>

        <button className="flex items-center space-x-1 hover:text-yellow-500 transition">
          <img
            src={NotificationIcon}
            alt="Notification Icon"
          
          />
          <span className="text-sm font-medium">Notifications</span>
        </button>
      </div>
    </div>
  );
};

export default Newherotop;
